import {
  SET_VAULTING_REQUESTS_SEARCH_CRITERIA,
  CLEAR_VAULTING_REQUESTS_SEARCH_CRITERIA,
} from '../actions/actionTypes';

import { pageSize } from '../../pages/VaultingRequests/constants';

const initialState = {
  limit: pageSize,
  offset: 0,
  sort: '-createdOn',
};

const vaultingRequestsSearchCriteriaReducer = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case SET_VAULTING_REQUESTS_SEARCH_CRITERIA:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_VAULTING_REQUESTS_SEARCH_CRITERIA:
      return initialState;
    default:
      return state;
  }
};

export default vaultingRequestsSearchCriteriaReducer;
